import React from 'react';
import PropTypes from 'prop-types';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	IconButton,
	Button,
	Link,
} from '@mui/material';

const SocialMediaSuccessDialog = ({
	isOpen,
	onClose,
	postResults,
	socialMediaIcons,
	formatAccountName,
	isVideoMedia,
	intl,
}) => {
	return (
		<Dialog fullWidth maxWidth="sm" open={isOpen} onClose={onClose}>
			<DialogTitle>
				{intl.formatMessage({
					id: 'pages.MediaFiles.components.ShareToSocialMedia.SocialMediaResponseTitle',
				})}
			</DialogTitle>

			<DialogContent dividers>
				{postResults.some(({ status }) => status === 'success') &&
					(isVideoMedia ? (
						<Typography>
							{intl.formatMessage({
								id:
									'pages.MediaFiles.components.ShareToSocialMedia.SocialMediaResponseVideoSuccess',
							})}
						</Typography>
					) : (
						<Typography>
							{intl.formatMessage({
								id: 'pages.MediaFiles.components.ShareToSocialMedia.SocialMediaResponseSuccess',
							})}
						</Typography>
					))}

				{postResults.some(({ status }) => status === 'scheduled') && (
					<Typography>
						{intl.formatMessage({
							id: 'pages.MediaFiles.components.ShareToSocialMedia.SocialMediaResponseSchedule',
						})}
					</Typography>
				)}

				<ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
					{postResults.map(({ platform, status, postUrl, message }) => (
						<li key={platform} style={{ listStyleType: 'disc', marginBottom: '8px' }}>
							<div
								style={{
									display: 'flex',
									alignItems:
										socialMediaIcons[platform] && status === 'success' ? 'center' : 'flex-start',
								}}
							>
								{socialMediaIcons[platform] && (
									<IconButton color="inherit" size="small">
										{socialMediaIcons[platform]}
									</IconButton>
								)}
								{status === 'success' ? (
									<Link
										href={postUrl}
										target="_blank"
										rel="noopener noreferrer"
										style={{ fontWeight: 'bold' }}
									>
										{formatAccountName(platform)}
									</Link>
								) : status === 'scheduled' ? (
									<Typography>{formatAccountName(platform)}</Typography>
								) : (
									<>
										<Typography style={{ marginLeft: '6px' }}>
											{formatAccountName(platform)}:{' '}
										</Typography>
										<Typography component="span" style={{ marginLeft: '4px' }} color="error">
											{message}
										</Typography>
									</>
								)}
							</div>
						</li>
					))}
				</ul>
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose} color="primary">
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

// export default SocialMediaSuccessDialog;
SocialMediaSuccessDialog.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	postResults: PropTypes.arrayOf(
		PropTypes.shape({
			platform: PropTypes.string.isRequired,
			status: PropTypes.string.isRequired,
			postUrl: PropTypes.string,
			message: PropTypes.string,
		})
	).isRequired,
	socialMediaIcons: PropTypes.object.isRequired,
	formatAccountName: PropTypes.func.isRequired,
	isVideoMedia: PropTypes.bool.isRequired,
	intl: PropTypes.object.isRequired,
};

export default SocialMediaSuccessDialog;
